"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranscriptItemListSchema = exports.TranscriptItemSchema = void 0;
const zod_1 = require("zod");
const list_1 = require("../list");
exports.TranscriptItemSchema = zod_1.z
    .object({
    role: zod_1.z.enum(['user', 'assistant']),
    text: zod_1.z.string(),
    timestamp: zod_1.z.date().openapi({ type: 'string', format: 'date-time' }),
})
    .openapi('TranscriptItem');
exports.TranscriptItemListSchema = (0, list_1.ListResponseSchema)(exports.TranscriptItemSchema, {
    title: 'TranscriptItemList',
});
//# sourceMappingURL=transcriptSchema.js.map